import { Button, DataSource, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutFuelTransactionsProcessingReady extends Layout {
    buttonHold: Button;
    panelTaskFilters: Panel;
    sourceFuelDetailList: DataSource;
    tableReadyTransactions: Table;
}
